<template>
  <div class="seletor-produtos-garcom">
    <!-- Header fixo: busca sempre visivel + chips de categoria sticky -->
    <div class="spg-toolbar">
      <div class="spg-busca">
        <div class="spg-busca-input">
          <i class="fas fa-search spg-busca-icone"></i>
          <input
            ref="buscaInput"
            v-model.trim="busca"
            type="search"
            class="form-control form-control-sm"
            placeholder="Buscar item ou código"
            autocomplete="off"
          />
          <button
            v-if="busca"
            type="button"
            class="spg-busca-limpar"
            title="Limpar busca"
            @click="limparBusca"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <div class="spg-chips">
        <button
          type="button"
          class="spg-chip"
          :class="{ 'spg-chip-ativo': !categoriaAtiva }"
          @click="selecionarCategoria(null)"
        >
          Todos
        </button>
        <button
          v-for="grupo in grupos"
          :key="grupo.id"
          type="button"
          class="spg-chip"
          :class="{ 'spg-chip-ativo': categoriaAtiva === grupo.id }"
          :ref="(el) => registrarChip(el, grupo.id)"
          @click="selecionarCategoria(grupo.id)"
        >
          {{ grupo.nome }}
        </button>
      </div>
    </div>

    <!-- Corpo rolavel (altura controlada pelo container do modal) -->
    <div class="spg-corpo">
      <div v-if="carregando" class="spg-estado spg-estado-load">
        <i class="fas fa-spinner fa-spin"></i>
        <span>Carregando produtos...</span>
      </div>

      <div v-else-if="erro" class="spg-estado spg-estado-erro">
        <span>{{ erro }}</span>
        <button class="btn btn-sm btn-light ml-2" @click="recarregar">
          Tentar novamente
        </button>
      </div>

      <div
        v-else-if="!busca && !gruposVisiveis.length"
        class="spg-estado"
      >
        Nenhum produto de restaurante encontrado.
        <small class="d-block mt-1 text-muted">
          Verifique se os produtos estão marcados como restaurante e possuem uma
          categoria (grupo) no cadastro.
        </small>
      </div>

      <!-- Resultado de busca (global, ignora categoria) -->
      <div v-else-if="busca" class="spg-grid">
        <button
          v-for="produto in resultadosBusca"
          :key="'busca-' + produto.id"
          type="button"
          class="spg-card"
          :class="{ 'spg-card-adicionado': quantidadeAdicionada(produto.id) }"
          @click="adicionarOuDetalhar(produto, $event)"
        >
          <div class="spg-card-topo">
            <div class="spg-card-imagem" :style="imagemStyle(produto)">
              <span v-if="!produto.imagem" class="spg-card-iniciais">{{
                iniciais(produto.descricao)
              }}</span>
            </div>
            <b-badge
              v-if="quantidadeAdicionada(produto.id)"
              pill
              variant="primary"
              class="spg-card-badge"
            >
              {{ quantidadeAdicionada(produto.id) }}
            </b-badge>
          </div>
          <div class="spg-card-corpo">
            <div class="spg-card-nome">{{ produto.descricao }}</div>
            <div class="spg-card-preco">
              {{ formatMoney(produto.preco) }}
            </div>
          </div>
        </button>
        <div v-if="!resultadosBusca.length" class="spg-estado spg-vazio-busca">
          <span>Nenhum item encontrado para "{{ busca }}".</span>
          <button class="btn btn-sm btn-link" @click="limparBusca">
            Limpar busca
          </button>
        </div>
      </div>

      <!-- Por categoria -->
      <div v-else>
        <div
          v-for="grupo in gruposVisiveis"
          :key="grupo.id"
          class="spg-categoria"
          :data-categoria-id="grupo.id"
        >
          <div class="spg-categoria-titulo">{{ grupo.nome }}</div>
          <div class="spg-grid">
            <button
              v-for="produto in grupo.produtos"
              :key="produto.id"
              type="button"
              class="spg-card"
              :class="{
                'spg-card-adicionado': quantidadeAdicionada(produto.id),
              }"
              @click="adicionarOuDetalhar(produto, $event)"
            >
              <div class="spg-card-topo">
                <div
                  class="spg-card-imagem"
                  :style="imagemStyle(produto)"
                >
                  <span v-if="!produto.imagem" class="spg-card-iniciais">{{
                    iniciais(produto.descricao)
                  }}</span>
                </div>
                <b-badge
                  v-if="quantidadeAdicionada(produto.id)"
                  pill
                  variant="primary"
                  class="spg-card-badge"
                >
                  {{ quantidadeAdicionada(produto.id) }}
                </b-badge>
              </div>
              <div class="spg-card-corpo">
                <div class="spg-card-nome">{{ produto.descricao }}</div>
                <div class="spg-card-preco">
                  {{ formatMoney(produto.preco) }}
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="spg-rodape">
      <small class="text-muted">
        Toque para adicionar (1 unidade). Para quantidade/observação, segure o
        card.
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeletorProdutosGarcom",
  props: {
    // Quantidades ja adicionadas na sessao, no formato { [produtoId]: numero }
    // Permite mostrar o badge de contagem no card.
    quantidades: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      grupos: [],
      carregando: false,
      erro: "",
      busca: "",
      categoriaAtiva: null,
      carregado: false,
      timerPressionado: null,
      pressAtivo: false,
    };
  },
  // Auto-carrega o cardapio assim que o componente eh montado. Isso torna o
  // carregamento robusto contra condicoes de corrida (o modal do BootstrapVue
  // pode renderizar o conteudo de forma assincrona, fazendo a chamada externa
  // via $ref falhar por timing).
  mounted() {
    this.carregarCardapio();
  },
  computed: {
    produtosAchatados() {
      return this.grupos.flatMap((grupo) => grupo.produtos || []);
    },
    resultadosBusca() {
      const termo = this.normalizar(this.busca);
      if (!termo) {
        return [];
      }
      return this.produtosAchatados.filter((produto) => {
        return (
          this.normalizar(produto.descricao).includes(termo) ||
          String(produto.id || "") === termo
        );
      });
    },
    gruposVisiveis() {
      if (this.categoriaAtiva === null) {
        return this.grupos;
      }
      return this.grupos.filter((grupo) => grupo.id === this.categoriaAtiva);
    },
  },
  methods: {
    async carregarCardapio(force = false) {
      if (!force && this.carregado && this.grupos.length) {
        return;
      }
      this.carregando = true;
      this.erro = "";
      try {
        const { data } = await this.$http.post(
          "/produtos/restaurante/cardapio-garcom"
        );
        const payload = data?.data ?? data ?? [];
        this.grupos = Array.isArray(payload) ? payload : [];
        this.carregado = true;
      } catch (error) {
        this.erro = "Não foi possível carregar os produtos. Tente novamente.";
      } finally {
        this.carregando = false;
      }
    },
    recarregar() {
      this.carregarCardapio(true);
    },
    limparBusca() {
      this.busca = "";
    },
    selecionarCategoria(id) {
      this.categoriaAtiva = id;
      this.rolarChipAtivoParaVisivel(id);
    },
    registrarChip(el) {
      // No-op necessario para o ref callback do Vue 2 (placeholder).
    },
    rolarChipAtivoParaVisivel(id) {
      this.$nextTick(() => {
        const chips = this.$el.querySelectorAll(".spg-chip");
        const alvo = id === null ? chips[0] : Array.from(chips).find((chip) =>
          chip.classList.contains("spg-chip-ativo")
        );
        if (alvo && typeof alvo.scrollIntoView === "function") {
          alvo.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      });
    },
    adicionarOuDetalhar(produto, event) {
      // Toque longo (hold) ou botao auxiliar = abrir mini-form de
      // quantidade/observacao. Toque curto = adicionar 1 direto.
      if (this.pressAtivo) {
        this.$emit("select", produto);
        return;
      }
      this.$emit("quick-add", produto);
    },
    quantidadeAdicionada(id) {
      return Number(this.quantidades?.[id] || 0);
    },
    iniciais(nome) {
      const texto = String(nome || "").trim();
      if (!texto) {
        return "?";
      }
      return texto.substring(0, 2).toUpperCase();
    },
    imagemStyle(produto) {
      if (!produto.imagem) {
        return {};
      }
      return { backgroundImage: `url('${produto.imagem}')` };
    },
    normalizar(texto) {
      return String(texto || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    formatMoney(valor) {
      const numero = Number(valor || 0);
      return numero.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>

<style scoped>
.seletor-produtos-garcom {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Toolbar fixo no topo */
.spg-toolbar {
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  padding-bottom: 8px;
}

.spg-busca {
  margin-bottom: 8px;
}
.spg-busca-input {
  position: relative;
  display: flex;
  align-items: center;
}
.spg-busca-icone {
  position: absolute;
  left: 10px;
  color: #b5b5c3;
  font-size: 0.8rem;
  pointer-events: none;
}
.spg-busca-input input {
  padding-left: 30px;
  border-radius: 8px;
  background: #f3f6f9;
  border-color: transparent;
}
.spg-busca-input input:focus {
  background: #fff;
  border-color: #3699ff;
}
.spg-busca-limpar {
  position: absolute;
  right: 8px;
  background: transparent;
  border: none;
  color: #b5b5c3;
  cursor: pointer;
  padding: 4px;
  font-size: 0.8rem;
}

/* Chips de categoria (rolam horizontalmente) */
.spg-chips {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 2px 0 6px;
  scrollbar-width: thin;
}
.spg-chips::-webkit-scrollbar {
  height: 4px;
}
.spg-chips::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}
.spg-chip {
  flex: 0 0 auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  color: #3f4254;
  border-radius: 999px;
  padding: 7px 16px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  min-height: 34px;
}
.spg-chip-ativo {
  background: #3699ff;
  color: #fff;
  border-color: #3699ff;
}

/* Corpo rolavel: ocupa o espaco restante do flex */
.spg-corpo {
  flex: 1 1 auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  min-height: 180px;
}

.spg-estado {
  text-align: center;
  color: #b5b5c3;
  padding: 28px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.spg-estado-load i {
  margin-right: 6px;
}
.spg-estado-erro {
  color: #f64e60;
}
.spg-vazio-busca {
  grid-column: 1 / -1;
}

/* Grid de produtos: denso e responsivo */
.spg-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(118px, 1fr));
  gap: 8px;
}
.spg-card {
  display: flex;
  flex-direction: column;
  text-align: left;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 6px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.1s;
  width: 100%;
  min-height: 44px;
}
.spg-card:hover {
  border-color: #3699ff;
  box-shadow: 0 2px 8px rgba(54, 153, 255, 0.12);
}
.spg-card:active {
  transform: scale(0.97);
}
.spg-card-adicionado {
  border-color: #3699ff;
  box-shadow: 0 0 0 2px rgba(54, 153, 255, 0.25);
}

.spg-card-topo {
  position: relative;
  width: 100%;
}
.spg-card-imagem {
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 8px;
  background-color: #f3f6f9;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spg-card-iniciais {
  font-weight: 700;
  color: #b5b5c3;
  font-size: 1rem;
}
.spg-card-badge {
  position: absolute;
  top: 6px;
  right: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.spg-card-corpo {
  padding: 6px 4px 2px;
}
.spg-card-nome {
  font-weight: 600;
  font-size: 0.78rem;
  color: #181c32;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 1.9em;
}
.spg-card-preco {
  font-size: 0.78rem;
  color: #3699ff;
  font-weight: 700;
  margin-top: 2px;
}

.spg-categoria {
  margin-bottom: 14px;
}
.spg-categoria-titulo {
  font-weight: 700;
  font-size: 0.85rem;
  color: #181c32;
  margin: 4px 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 5;
}

.spg-rodape {
  flex: 0 0 auto;
  padding-top: 6px;
}

/* Mobile: 2 colunas garantidas, cards um pouco maiores */
@media (max-width: 575.98px) {
  .spg-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
  .spg-card-nome {
    font-size: 0.8rem;
  }
}
</style>
